import * as yup from 'yup'

export const schema = yup.object().shape({
  startDate: yup.date()
    .nullable()
    .transform((curr, orig) => (orig === '' ? null : curr))
    .required('Selecione a data inicio'),
  endDate: yup.date()
    .nullable()
    .required('Selecione a data fim')
    .transform((curr, orig) => (orig === '' ? null : curr))
    .min(
      yup.ref('startDate'),
      'A data final não pode ser menor do que a data inicial',
    ),
})
